import { getInitials } from "creso-core/utils";
import { Avatar, HoldingPatternBadge } from "web-core";
import { cn } from "web-design-system";
import { type ReactNode } from "react";
import { JOINT_CLIENT_HOLDING_PATTERNS } from "creso-core/constants";
import { ClientHoldingPattern } from "creso-core/types";

export type ClientStatusMemberDisplay = {
  name: string;
  holdingPattern?: ClientHoldingPattern;
};

export function ClientStatusLayout({
  memberDisplay,
  children,
  className,
}: {
  memberDisplay?: ClientStatusMemberDisplay;
  children: ReactNode;
  className?: string;
}) {
  if (!memberDisplay) {
    return (
      <div className={cn("flex flex-row rounded-lg bg-card", className)}>
        {children}
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex w-full min-h-15 flex-row items-center rounded-lg bg-card gap-4",
        className
      )}
    >
      <div className="flex shrink-0 items-center gap-2 self-stretch py-3 pl-4 pr-3">
        <Avatar fallback={getInitials(memberDisplay.name)} size="sm" />
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold whitespace-nowrap">
            {memberDisplay.name}
          </span>
          {memberDisplay.holdingPattern &&
          JOINT_CLIENT_HOLDING_PATTERNS.includes(
            memberDisplay.holdingPattern
          ) ? (
            <HoldingPatternBadge
              holdingPattern={memberDisplay.holdingPattern}
            />
          ) : null}
        </div>
      </div>
      <div className="flex min-w-0 flex-1 items-center">{children}</div>
    </div>
  );
}

export function clientStatusContentClassName(
  memberDisplay?: ClientStatusMemberDisplay,
  className?: string
) {
  return cn(
    "flex h-full w-full items-center py-3 gap-3",
    memberDisplay ? "pr-4 pl-0" : "px-4",
    className
  );
}
